import { motion } from "framer-motion";

// Fade + subtle rise on scroll into view. Editorial, luxurious cadence.
export const Reveal = ({
  children,
  delay = 0,
  y = 24,
  duration = 0.9,
  className = "",
  as: Tag = "div",
  once = true,
  amount = 0.2,
}) => {
  const MotionTag = motion(Tag);
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
